<template>
  <div>
    <vxe-table
        class="table-style common-shadow"
        stripe
        align="center"
        highlight-current-row
        highlight-hover-row
        border="inner"
        :loading="loading"
        :data="dictList"
    >
      <vxe-table-column field="id" title="序号">
        <template slot-scope="{ row }">
          <span>{{ row.id }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="dictCode"

          title="类型"
          show-overflow
      ></vxe-table-column>
      <vxe-table-column
          field="dictText"

          title="内容"
          show-overflow
      ></vxe-table-column>
      <vxe-table-column
          field="note"

          title="描述"
          show-overflow
      ></vxe-table-column>
      <vxe-table-column field="type" title="操作">
        <template v-slot="{ row }">
          <div>
            <a
                style="color: #409eff; margin-left: 10px"
                v-if="row.dictCodeP !== 0"
                @click.stop="update(row)"
            >编辑</a
            >
          </div>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-modal v-model="isShowMenuInfo" :title="modalTitle" @close="closeModal" height="500" width="500"
               destroy-on-close resize position="center" transfer>
      <create-dict-modal ref="dictModal" :isSystem="true" @afterSave="afterSave" @close="closeModal"></create-dict-modal>
    </vxe-modal>
  </div>
</template>

<script>
import {apiGet} from "../../utils/api";
import $api from "@/apiProvider";
import {hideLoading, showLoading} from "@/utils/util";
import CreateDictModal from "@/views/authorization/CreateMenuDictModal";

export default {
  components: {CreateDictModal},
  name: 'checkCN',
  data() {
    return {
      defaultExpandKeys: [],
      dict: '',
      dictList: [],
      isShowMenuInfo: false,
      modalTitle: "",
      loading: false,
      searchData: [],
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    update(row) {
      this.modalTitle = "修改字典";
      this.isShowMenuInfo = true;
      this.$nextTick(() => {
        this.$refs.dictModal.setUpdate(row);
      });
    },
    afterSave() {
      this.isShowMenuInfo = false;
      this.init();
    },
    closeModal() {
      this.isShowMenuInfo = false;
      this.$refs.dictModal.reset();
    },
    init() {
      this.getDictList();
    },
    async remove(row) {
      let confirmRes = await this.$XModal.confirm(
          "删除后不可恢复",
          "是否删除？"
      );
      if (confirmRes === "confirm") {
        let res = await $api.dict.post("addOrUpdateDic/", {
          id: row.id,
          isDelete: 1,
        });
        if (res.status === 1) {
          this.$Message.success("删除成功");
          this.init();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      }
    },
    async getDictList() {
      let searchData = [];
      this.loading = true;
      let res = await $api.dict.get("getDicByParentCode/15900");
      this.loading = false;
      if (res.status === 1) {
        this.dictList = res.data;

      } else {
        this.$XModal.message(res.message);
      }
    },
  }
}
</script>